import { useEffect, useState } from "react"

import { getGlobalFilesOverview } from "../api/global-files.services.ts"
import type { GlobalFilesOverview } from "../types/global-files-overview.types.ts"

type OverviewState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "loaded"; overview: GlobalFilesOverview }

/** The Overview tab's KPI/breakdown/health payload — one request, refetched
 * on demand (e.g. after an upload) via the returned `refresh`. */
export function useGlobalFilesOverview() {
  const [state, setState] = useState<OverviewState>({ status: "loading" })
  const [refreshToken, setRefreshToken] = useState(0)

  useEffect(() => {
    let cancelled = false
    setState((prev) => (prev.status === "loaded" ? prev : { status: "loading" }))
    void getGlobalFilesOverview().then((response) => {
      if (cancelled) return
      if (!response.ok || !response.data) {
        setState({ status: "error" })
        return
      }
      setState({ status: "loaded", overview: response.data })
    })
    return () => {
      cancelled = true
    }
  }, [refreshToken])

  return { ...state, refresh: () => setRefreshToken((n) => n + 1) }
}
